import {Button, message, Modal} from 'antd';

/**
 * URL安全的Base64编码
 * @param str - 要编码的字符串
 * @returns URL安全的Base64编码字符串
 */
export const urlSafeBase64Encode = (str: string): string => {
  // 使用 unescape(encodeURIComponent()) 处理 Unicode 字符，然后转换为 Base64
  // 这种方式兼容腾讯云水印服务的编码要求
  const base64 = btoa(unescape(encodeURIComponent(str)));
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

/**
 * 通用的复制到剪贴板函数（用于单个组件）
 * @param content - 要复制的内容
 * @param successMessage - 成功提示消息
 */
export const copyToClipboard = (content: string, successMessage: string = '复制成功') => {
  navigator.clipboard.writeText(content).then(() => {
    message.success(successMessage);
  }).catch((error) => {
    console.error('复制失败:', error);
    // 复制失败时显示弹框让用户手动复制
    Modal.info({
      title: '复制失败',
      content: (
        <div>
          <p>自动复制失败，请手动复制以下内容：</p>
          <div style={{ 
            wordBreak: 'break-all', 
            fontSize: '12px', 
            background: '#f5f5f5', 
            padding: '8px', 
            borderRadius: '4px',
            border: '1px solid #d9d9d9',
            marginTop: '8px',
            maxHeight: '200px',
            overflow: 'auto'
          }}>
            {content}
          </div>
        </div>
      ),
      width: 500,
      footer: [
        <Button key="close" onClick={() => Modal.destroyAll()}>
          关闭
        </Button>
      ]
    });
  });
};

/**
 * 通用的复制到剪贴板函数（用于批量操作）
 * @param content - 要复制的内容
 * @param successMessage - 成功提示消息
 */
export const copyToClipboardAsync = async (content: string, successMessage: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(content);
    message.success(successMessage);
  } catch (error) {
    console.error('复制失败:', error);
    // 复制失败时显示弹框让用户手动复制
    Modal.info({
      title: '复制失败',
      content: (
        <div>
          <p>自动复制失败，请手动复制以下内容：</p>
          <div style={{ 
            wordBreak: 'break-all', 
            fontSize: '12px', 
            background: '#f5f5f5', 
            padding: '8px', 
            borderRadius: '4px',
            border: '1px solid #d9d9d9',
            marginTop: '8px',
            maxHeight: '300px',
            overflow: 'auto'
          }}>
            {content}
          </div>
        </div>
      ),
      width: 600,
      footer: [
        <Button key="close" onClick={() => Modal.destroyAll()}>
          关闭
        </Button>
      ]
    });
  }
};

/**
 * 水印文字本地存储相关函数
 */
export const getStoredWatermarkText = (): string => {
  return localStorage.getItem('imgcloud_watermark_text') || '';
};

export const saveWatermarkText = (text: string): void => {
  localStorage.setItem('imgcloud_watermark_text', text);
};

/**
 * 水印图片URL本地存储相关函数
 */
export const getStoredWatermarkImageUrl = (): string => {
  return localStorage.getItem('imgcloud_watermark_image_url') || '';
};

export const saveWatermarkImageUrl = (url: string): void => {
  localStorage.setItem('imgcloud_watermark_image_url', url);
}; 